import React from 'react';
import { Typography, Stack } from '@mui/material';

import Image from '../Image';
import { EmptyContentProps } from './props';

const EmptyContent: React.FC<EmptyContentProps> = ({
  title,
  description,
  img,
  sx,
  ...other
}) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: 1,
        textAlign: 'center',
        p: theme => theme.spacing(8, 2),
        ...sx,
      }}
      {...other}
    >
      <Image
        disabledEffect
        alt="Empty content"
        src={img || '/assets/illustrations/illustration_empty_content.svg'}
        sx={{ height: 240, marginBottom: 3 }}
      />

      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
};

export default EmptyContent;
